module.exports = __webpack_public_path__ + "media/src/images/icons/eye/closed-active-37fe7467c5906d1a453d39f68d993bc5.svg";